import { useState } from "react"
import ChainHalo from "./ChainHalo.jsx"
import { ICON_HEIGHT } from "./haloGeometry"
import brain from "./brain.png"
import chainLink from "./chain-link.png"
import liveIndicator from "./live-indicator.png"
import { setupContent, setupLabels } from "./setupContent"

const STEP_MARK_HEIGHT = 32
const marks = [
  { src: brain, height: STEP_MARK_HEIGHT },
  { src: chainLink, height: ICON_HEIGHT },
  { src: liveIndicator, height: STEP_MARK_HEIGHT },
]

function GlowMark({ lit, src, height }) {
  return (
    <>
      <ChainHalo lit={lit} src={src} height={height} />
      <img src={src} alt="" className="relative z-10 w-auto" style={{ height }} />
    </>
  )
}

function StepIcon({ index, lit }) {
  const mark = marks[index]
  return (
    <span className="relative flex items-start" aria-hidden="true">
      <GlowMark lit={lit} src={mark.src} height={mark.height} />
    </span>
  )
}

export default function SetupSection() {
  const [litStep, setLitStep] = useState(null)

  return (
    <section className="ml-[calc(50vw-50%-1.5rem)] flex w-full flex-col gap-12 lg:gap-[72px]">
      <div className="grid w-full grid-cols-1 items-end gap-x-6 gap-y-6 lg:grid-cols-12">
        <h2 className="text-balance text-[40px] font-bold leading-[48px] tracking-[-0.04em] text-[#171717] max-md:text-[28px] max-md:leading-8 lg:col-span-5">
          {setupContent.title}
        </h2>
        <p className="text-pretty text-[16px] font-normal leading-6 text-[#4D4D4D] lg:col-span-4 lg:col-start-6 lg:text-[18px] lg:leading-7">
          {setupContent.lead}
        </p>
        <p className="text-pretty text-[16px] font-normal leading-6 text-[#4D4D4D] lg:col-span-10 lg:col-start-1 lg:text-[18px] lg:leading-7">
          {setupContent.detail}
        </p>
      </div>
      <ul className="grid w-full list-none grid-cols-1 gap-6 p-0 lg:grid-cols-3">
        {setupContent.steps.map((sentence, index) => (
          <li
            key={setupLabels[index]}
            className="flex h-full flex-col justify-center gap-6 rounded-[2px] border border-[#E6E6E6] p-6"
            onMouseEnter={() => setLitStep(index)}
            onMouseLeave={() => setLitStep(null)}
          >
            <StepIcon index={index} lit={litStep === index} />
            <div className="flex flex-col gap-2">
              <p className="text-[14px] font-medium leading-5 text-[#171717]">
                {setupLabels[index]}
              </p>
              <p className="text-pretty text-[16px] font-normal leading-6 text-[#4D4D4D]">
                {sentence}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </section>
  )
}
